import React, { Component } from "react";
import Auth from "j-toker";
import LocalizedStrings from "react-localization";
import en from "../localization/localization-en.json";

import { getUser } from "../helper/user_helper";

import ReactPhoneInput from "react-phone-input-2";
import { isValidNumber } from "libphonenumber-js";

import { checkUsername } from "../helper/user_helper";
import Loader from "../components/loader";

import qs from "qs";

let strings = new LocalizedStrings({ en });
class SignUp extends Component {
  state = {
    email: "",
    password: "",
    password_confirmation: "",
    username: "",
    errors: "",
    first_name: "",
    last_name: "",
    phone_number: "",
    show_first_page: true,
    loaded: true,
    pushTo: "/profile"
  };
  componentDidMount() {
    // Check if user is already login
    const self = this;
    this.userCall = getUser();
    this.userCall.promise.then(answer => {
      if (answer.signedIn === true) {
        self.props.history.push("/profile");
        return;
      }
    });
    if (!this.props.location) return;
    if (!this.props.location.search) return;
    const query = qs.parse(this.props.location.search, {
      ignoreQueryPrefix: true
    });
    if (query.list) {
      this.setState({ pushTo: "/list/" + query.list });
    }
  }

  componentWillUnmount() {
    if (this.userCall) {
      this.userCall.cancel();
    }
  }

  render() {
    if (this.state.loaded === false) {
      return <Loader loaded={false} />;
    }
    return (
      <div className="center max_width_300 allow_scroll">
        {this.renderFirstSignUp()}
        {this.renderSecondSignUp()}

        {this.renderErrorMessage()}
      </div>
    );
  }

  renderFirstSignUp() {
    var style = { width: "0px" };
    if (this.state.show_first_page === true) {
      style = { width: "100%" };
    }

    var classFirstLabel = "yaystack_input_text_label pt-5";
    if (this.props.username) {
      classFirstLabel = "yaystack_input_text_label";
    }

    return (
      <form style={style} className="sign_up_div" onSubmit={this.changePage}>
        <label className={classFirstLabel}>
          <input
            className="yaystack_input_text mb-3"
            type="text"
            required={true}
            value={this.state.first_name}
            placeholder={strings.first_name}
            onChange={this.handleChangeFirstName}
          />
        </label>
        <br />
        <label className="yaystack_input_text_label">
          <input
            className="yaystack_input_text mb-3"
            type="text"
            required={true}
            value={this.state.last_name}
            placeholder={strings.last_name}
            onChange={this.handleChangeLastName}
          />
        </label>
        <br />
        <label className="yaystack_input_text_label">
          <input
            className="yaystack_input_text mb-3"
            type="text"
            minLength="3"
            required={true}
            value={this.state.username}
            placeholder={strings.username}
            onChange={this.handleChangeUsername}
            autoCapitalize="none"
          />
        </label>
        <br />
        <label className="yaystack_input_text_label">
          <ReactPhoneInput
            className="yaystack_input_text mb-3"
            defaultCountry={"us"}
            placeholder={strings.phone_number}
            value={this.state.phone_number}
            onChange={value => this.setState({ phone_number: value })}
          />
        </label>
        <br />
        <input
          type="submit"
          value={strings.next}
          className="btn btn_primary btn_yaystack mb-3 width_100"
        />
        <br />
        <label style={{ fontFamily: "DIN Pro Light", fontSize: "14px" }}>
          By signing up, you agree to our{" "}
          <a
            href="https://business.yaystackapp.com/#/terms"
            style={{
              fontFamily: "DIN Pro Light",
              fontSize: "14px",
              color: "#ff5116"
            }}
            target="_blank"
          >
            Terms
          </a>
          .
        </label>
      </form>
    );
  }

  renderSecondSignUp() {
    var style = { width: "0px" };
    if (this.state.show_first_page === false) {
      style = { width: "100%" };
    }

    return (
      <form
        onSubmit={this.handleSignUpClick}
        style={style}
        className="sign_up_div"
      >
        <button
          className="btn btn_primary btn_yaystack width_100 mb-3"
          onClick={this.changePage}
        >
          {strings.previous}
        </button>
        <label className="yaystack_input_text_label">
          <input
            className="yaystack_input_text mb-3"
            type="email"
            required={true}
            value={this.state.email}
            placeholder={strings.email}
            onChange={this.handleChangeEmail}
          />
        </label>
        <br />

        <label className="yaystack_input_text_label">
          <input
            className="yaystack_input_text mb-3"
            type="password"
            required={true}
            minLength="8"
            value={this.state.password}
            placeholder={strings.password}
            onChange={this.handleChangePassword}
          />
        </label>
        <br />
        <label className="yaystack_input_text_label">
          <input
            className="yaystack_input_text mb-3"
            type="password"
            required={true}
            minLength="8"
            value={this.state.password_confirmation}
            placeholder={strings.password_confirmation}
            onChange={this.handleChangePasswordConfirmation}
          />
        </label>
        <br />

        <input
          type="submit"
          value={strings.sign_up}
          className="btn btn_primary btn_yaystack mb-3 width_100"
        />
        <br />
        <label style={{ fontFamily: "DIN Pro Light", fontSize: "14px" }}>
          By Signing Up, you agree to our{" "}
          <a
            href="https://business.yaystackapp.com/#/terms"
            style={{
              fontFamily: "DIN Pro Light",
              fontSize: "14px",
              color: "#ff5116"
            }}
            target="_blank"
          >
            Terms
          </a>
          .
        </label>
      </form>
    );
  }

  changePage = event => {
    event.preventDefault();

    if (this.state.show_first_page) {
      if (!this.state.phone_number) {
        this.setState({ phone_number: "" });
      } else if (this.state.phone_number === "+") {
        this.setState({ phone_number: "" });
      } else if (this.state.phone_number === "+11234567890") {
        this.setState({ phone_number: "" });
      } else if (!isValidNumber(this.state.phone_number)) {
        let errors = "Wrong Phone Number";
        this.setState({ errors });
        return;
      }

      //Check Username before
      this.setState({ errors: "", loaded: false });
      const self = this;
      this.checkUsernameCall = checkUsername(
        this.state.username,
        this.state.phone_number
      );
      this.checkUsernameCall.promise
        .then(answer => {
          const show_first_page = !self.state.show_first_page;
          self.setState({ show_first_page, loaded: true });
        })
        .catch(errors_ => {
          let errors = errors_.errors;
          self.setState({ errors, loaded: true });
        });
    } else {
      const show_first_page = !this.state.show_first_page;
      this.setState({ show_first_page });
    }
  };

  renderErrorMessage() {
    if (this.state.errors === "") return <label />;
    return <label className="alert alert-danger">{this.state.errors}</label>;
  }

  handleChangeEmail = event => {
    this.setState({ email: event.target.value });
  };

  handleChangePassword = event => {
    this.setState({ password: event.target.value });
  };

  handleChangePasswordConfirmation = event => {
    this.setState({ password_confirmation: event.target.value });
  };

  handleChangeUsername = event => {
    const username = event.target.value.toLowerCase();
    this.setState({ username });
  };

  handleChangeFirstName = event => {
    this.setState({ first_name: event.target.value });
  };

  handleChangeLastName = event => {
    this.setState({ last_name: event.target.value });
  };

  handleSignUpClick = event => {
    event.preventDefault();
    let errors = "";
    this.setState({ errors });

    if (!this.state.phone_number) {
      this.setState({ phone_number: "" });
    } else if (this.state.phone_number === "+") {
      this.setState({ phone_number: "" });
    } else if (this.state.phone_number === "+11234567890") {
      this.setState({ phone_number: "" });
    } else if (!isValidNumber(this.state.phone_number)) {
      let errors = "Wrong Phone Number";
      this.setState({ errors });
      return;
    }
    this.setState({ loaded: false });
    Auth.emailSignUp({
      email: this.state.email,
      password: this.state.password,
      password_confirmation: this.state.password_confirmation,
      username: this.state.username,
      first_name: this.state.first_name,
      last_name: this.state.last_name,
      phone_number: this.state.phone_number,
      invite_by_username: this.props.username
    })
      .then(
        function(user) {
          localStorage.setItem("user", JSON.stringify(user.data));
          this.props.history.push(this.state.pushTo);
        }.bind(this)
      )
      .fail(
        function(res) {
          if (res.data) {
            if (res.data.errors) {
              let errors = res.data.errors.full_messages;
              this.setState({ errors, loaded: true });
            } else {
              let errors = res.data.errors.join(", ");
              this.setState({ errors, loaded: true });
            }
          } else {
            let errors = strings.contact_yaystack_Support;
            this.setState({ errors, loaded: true });
          }
        }.bind(this)
      );
  };
}

export default SignUp;



// WEBPACK FOOTER //
// ./src/pages/sign_up.jsx